/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CenterBoxTransfer.vue?vue&type=template&id=c68297a0&scoped=true"
import script from "./CenterBoxTransfer.vue?vue&type=script&lang=js"
export * from "./CenterBoxTransfer.vue?vue&type=script&lang=js"
import style0 from "./CenterBoxTransfer.vue?vue&type=style&index=0&id=c68297a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68297a0",
  null
  
)

export default component.exports